import { useFormikContext } from "formik";
import React from "react";
import { Form, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useTranslation } from "react-i18next";
import { useRouter } from "src/hooks/useRouter";
import { localStrings } from "src/utils/localization";

interface TaxInvoiceInfo {
  owner: string;
  businessNumber: string;
  requestDate: string;
  issuer: string;
  phoneNumber: string;
  email: string;
}

interface CashPaymentProps {
  // depositor: string;
  // handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  // confirmPolicy: boolean;
  showTaxInvoiceFields: boolean;
  toggleTaxInvoidFields: () => void;
  taxInvoiceInfo: TaxInvoiceInfo;
  handleChangeTaxInvoice: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleChangeTaxRequestDate: (date: Date) => void;
}

const CashPayment: React.FC<CashPaymentProps> = ({
  // depositor,
  // handleChange,
  // confirmPolicy,
  showTaxInvoiceFields,
  toggleTaxInvoidFields,
  taxInvoiceInfo,
  handleChangeTaxInvoice,
  handleChangeTaxRequestDate,
}) => {
  const { values, handleChange, submitForm } = useFormikContext<any>();
  const { depositor, confirmPolicy } = values;
  const { t } = useTranslation();
  const { lang } = useRouter();
  const isFormInvalid =
    depositor === "" ||
    !confirmPolicy ||
    (showTaxInvoiceFields &&
      Object.values(taxInvoiceInfo).some((value) => value === ""));

  const renderInput = (field: keyof TaxInvoiceInfo) => (
    <Form.Group className="mt-3" controlId={field}>
      <Form.Label>{t(`cashStatus.taxInvoice.${field}`)}</Form.Label>
      <Form.Control
        name={field}
        value={taxInvoiceInfo[field]}
        onChange={handleChangeTaxInvoice}
        placeholder={t(`cashStatus.taxInvoice.placeHolder.${field}`)}
      />
    </Form.Group>
  );
  return (
    <div>
      <Form.Group className="mt-3">
        <Form.Label>{t("cashStatus.pay.sender")}</Form.Label>
        <Form.Control
          name="depositor"
          value={depositor}
          onChange={handleChange}
          placeholder={t("admin.upc.site.enterDeposit")}
        />
      </Form.Group>

      <Form.Group className="mt-3">
        <Form.Check
          type="checkbox"
          id="taxInvoidFields"
          style={{ padding: "0px" }}
          label={
            <label
              htmlFor="taxInvoidFields"
              className={`form-input-label app textEllipsis`}
            >
              {t("cashStatus.taxInvoice.title")}
            </label>
          }
          checked={showTaxInvoiceFields}
          onChange={toggleTaxInvoidFields}
        />
      </Form.Group>

      {showTaxInvoiceFields && (
        <>
          {renderInput("owner")}
          {renderInput("businessNumber")}

          <Form.Group className="mt-3">
            <Form.Label>{t("cashStatus.taxInvoice.requestDate")}</Form.Label>
            <DatePicker
              className="form-control"
              selected={
                taxInvoiceInfo.requestDate
                  ? new Date(taxInvoiceInfo.requestDate)
                  : null
              }
              onChange={handleChangeTaxRequestDate}
              dateFormat="yyyy-MM-dd"
              locale={lang}
              autoComplete="off"
            />
          </Form.Group>

          {renderInput("issuer")}
          {renderInput("phoneNumber")}
          {renderInput("email")}
        </>
      )}

      <Button
        variant="success"
        // className="w-100 mt-4"
        className="btn btn-green btn-40 width w-100p mg mt-10 pd py-10"
        // onClick={reqeustCash}
        onClick={submitForm}
        disabled={isFormInvalid}
      >
        {t("admin.cashMgnt.status.wait")}
      </Button>
    </div>
  );
};

export default CashPayment;
